import { useEffect } from 'react';
import { useThemeStore } from '../../store/themeStore';

/**
 * Hook para controlar o tema claro/escuro.
 * Sincroniza a classe `dark` no <html> com o store.
 */
export function useThemeMode() {
  const { mode, setMode } = useThemeStore();
  const effectiveTheme = mode;

  useEffect(() => {
    const root = document.documentElement;
    const apply = () => {
      const m = useThemeStore.getState().mode;
      root.classList.toggle('dark', m === 'dark');
    };
    apply();
    return useThemeStore.subscribe(apply);
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', effectiveTheme === 'dark');
  }, [effectiveTheme]);

  return { mode, setMode, effectiveTheme };
}
